module.exports = __webpack_public_path__ + "static/media/MOTIVATION_INT_EXT_POS.94555b68.md";